import { ReactNode } from "react";
import { theme, Typography } from "antd";

interface TextSummaryProps {
  children: ReactNode;
  className?: string;
}

export function TextSummary({ children, className }: TextSummaryProps) {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: token.marginSM,
        paddingTop: token.paddingSM,
        paddingBottom: 0,
        width: "100%",
      }}
    >
      <Typography.Text
        className="vzbl-text-3"
        style={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          wordWrap: "break-word",
          maxWidth: "100%",
          lineClamp: 3,
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
        }}
      >
        {children}
      </Typography.Text>
    </div>
  );
}
